import Api from '../api';

class AssetGroupService {
  createAssetGroup = async (payload: any, orgid?: string) => {
    let url = '/asset-group';
    if (orgid) {
      url += `?orgid=${orgid}`;
    }
    return Api.post(url, payload);
  }

  getAssetGroups = async (params: any) => {
    const query = new URLSearchParams(params).toString();
    let url = query ? `/asset-group?${query}` : '/asset-group';
    return Api.get(url);
  }

  getAssetGroupsForDemo = async (params: any) => {
    const query = new URLSearchParams(params).toString();
    let url = query ? `/asset-group-demo?${query}` : '/asset-group-demo';
    return Api.get(url);
  }

  getAssetGroupById = async (id: string, orgid?: string) => {
    let url = `/asset-group/${id}`;
    if (orgid) {
      url += `?orgid=${orgid}`;
    }
    return Api.get(url);
  }

  updateAssetGroup = async (id: string, payload: any, orgid?: string) => {
    let url = `/asset-group/${id}`;
    if (orgid) {
      url += `?orgid=${orgid}`;
    }
    return Api.put(url, payload);
  }

  deleteAssetGroup = async (id: string, orgid?: string) => {
    let url = `/asset-group/${id}`;
    if (orgid) {
      url += `?orgid=${orgid}`;
    }
    return Api.delete(url);
  }

  addAssetGroupAttachment = async (id: string, formData: FormData, orgid?: string) => {
    let url = `/asset-group/${id}/attachment`;
    if (orgid) {
      url += `?orgid=${orgid}`;
    }
    return Api.post(url, formData);
  }

  getAssetGroupAttachment = async (attachmentName: string) => {
    return Api.get(`/asset-group/attachment/${attachmentName}`, {
      responseType: 'blob',
    });
  }

  deleteAssetGroupAttachment = async (id: string, attachmentId: string, fileId: string, orgid?: string) => {
    let url = `/asset-group/${id}/attachment/${attachmentId}/file/${fileId}`;
    if (orgid) {
      url += `?orgid=${orgid}`;
    }
    return Api.delete(url);
  }
}

export default new AssetGroupService();

